module.exports = __webpack_public_path__ + "static/media/favicon-match.6b7f36c4.ico";